import { useState, useEffect, useContext } from "react";

import { api } from "../../../services/api";
import { Box } from "@mui/system";

// import MultiSelectFilter from "../../multiSelectFilter";
import valueRange from "../../valueRange";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import CardSys from "../../cardSys";
import { Grid } from "@mui/material";

import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import ModalSys from "../../modal";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button } from "@mui/material";
import { IconButton, Toolbar, Tooltip } from "@mui/material";
import bannertop from "../../../assets/bannertop.png";
import Divider from '@mui/material/Divider';
import Analytics from "../../analytics";
import GerarXlsx from "./hook/gerarXlsx";
import DateRangePickerValue from "../../dateRage";
import FormControl from "@mui/material/FormControl";
import { DataGrid, GridColDef, GridValueGetterParams } from '@mui/x-data-grid';
import React from "react";
import { PdfDashboardContext } from "../../../contexts/PdfDashboardContext";

const columns = [
  { field: 'CNPJ', headerName: 'CNPJ', width: 130 },
  { field: 'devedor', headerName: 'Cliene/Devedor', width: 220 },
  { field: 'contrato', headerName: 'Contrato', width: 100 },
  { field: 'status_acordo', headerName: 'Estágio', width: 130 },
  { field: 'data_entrada', headerName: 'Entrada', width: 160 },
  { field: 'titulo', headerName: 'Título', width: 130 },
  { field: 'vencimento', headerName: 'Vencimento', width: 170 },
  { field: 'valor_original', headerName: 'Valor Original', width: 130 },
  { field: 'saldo', headerName: 'Saldo', width: 130 },
  { field: 'data_acordo', headerName: 'Acordo', width: 160 },
  { field: 'id_acordo', headerName: 'ID do acordo', width: 130 },
  { field: 'data_finalizacao', headerName: 'Finalização', width: 170 },
];

export default function TableDashboardPdf({ children, data, enterpriseSelected, ...props }) {

  var total = 0;
  if (data) {
    total = data[0];
    data = data.filter(el => el.name != 'TOTAL');
  }
  
  return (
    <>
      <TableContainer component={Paper} sx={{ background: 'transparent', boxShadow: 'none', overflow: "hidden" }}>
        <Table sx={{ Width: 20 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow >
              <TableCell sx={{ paddingInline: "0.0px" }}></TableCell>
              <TableCell align="center" sx={{ width: 'fit-content', color: "#2c4992", fontWeight: "bold", fontSize: "0.7rem", paddingInline: "0px" }}>Qtd</TableCell>
              <TableCell align="right" sx={{ width: 'fit-content', color: "#2c4992", fontWeight: "bold", fontSize: "0.7rem", paddingInline: "0px" }}>Valor</TableCell>
              <TableCell align="center" sx={{ width: 'fit-content', color: "#2c4992", fontWeight: "bold", fontSize: "0.7rem", paddingInline: "0px" }}>%</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.map((e, index) => {
              const porcentNumber = e.pct;
              const porcentClena = parseFloat(porcentNumber);
              const pct = porcentClena.toFixed(1).replaceAll(".", ",");
              return (
                <TableRow
                  key={e.name}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 }, p:0 }}
                >
                  <TableCell align="right" component="th" scope="row" sx={{ fontSize: "0.6rem", paddingInline: "0px",paddingBlock:"0.0px"}}>
                    <Button sx={{ fontSize: "0.7rem", p: 0}} variant="plain">{e.name.length > 21 ? e.name.slice(0,21)+'...' : e.name }</Button>
                  </TableCell>
                  <TableCell align="center" sx={{ width: 'fit-content', fontSize: "0.7rem",p: 0, paddingInline: "0px", }}>{e.qtd}</TableCell>
                  <TableCell align="right" sx={{ width: 'fit-content', fontSize: "0.7rem",p: 0, paddingInline: "4px" }}>{e.val}</TableCell>
                  <TableCell align="center" sx={{ width: 'fit-content', fontSize: "0.7rem",p: 0, paddingInline: "px" }}>{pct}</TableCell>
                </TableRow>
              );
            })}
            <TableRow>
              <TableCell align="right" sx={{ width: 'fit-content', fontWeight: "bold", paddingInline: "0px", fontSize: "0.7rem", borderTop: "2px solid black" }}>TOTAL</TableCell>
              <TableCell align="center" sx={{ width: 'fit-content', fontWeight: "bold", paddingInline: "0px", fontSize: "0.7rem", borderTop: "2px solid black" }}> </TableCell>
              <TableCell align="right" sx={{ width: 'fit-content', fontWeight: "bold", paddingInline: "0px", fontSize: "0.7rem", borderTop: "2px solid black" }}>R${total.val}</TableCell>
              <TableCell align="center" sx={{ width: 'fit-content', fontWeight: "bold", paddingInline: "0px", fontSize: "0.7rem", borderTop: "2px solid black" }}></TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}